// extracted by mini-css-extract-plugin
module.exports = {"ConfirmInsurance":"ConfirmInsurance_ConfirmInsurance__IbosH"};